import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// The project's named font sizes (theme.extend.fontSize in tailwind.config.js;
// a test keeps the two lists equal). Plain tailwind-merge does not know them,
// so it read text-button-md as a colour and dropped it next to
// text-primary-foreground: <Button> lost its size, <Button size="sm"> its
// white text and <Input> its 16px phone size. Declared here, they merge as
// sizes — a later text-sm still replaces text-button-md, colours stay.
export const FONT_SIZE_TOKENS = [
  "display-xl", "display-lg",
  "heading-xl", "heading-lg", "heading-md", "heading-sm",
  "body-lg", "body-md", "body-sm",
  "label-lg", "label-md", "label-sm",
  "eyebrow", "button-lg", "button-md", "caption",
  "price-lg", "price-md", "price-sm",
];

// The other named tokens (tailwind.config.js), declared for the same reason:
// unknown to tailwind-merge, shadow-tk-card read as a shadow colour and
// z-overlay merged with nothing, so a page's override could not replace them.
export const SHADOW_TOKENS = ["tk-card", "tk-pop", "tk-search", "tk-dialog"];
export const Z_TOKENS = ["raised", "sticky", "header", "banner", "overlay", "dialog", "dropdown", "popover", "toast", "offline", "skip"];

const twMerge = extendTailwindMerge({
  extend: {
    theme: { text: FONT_SIZE_TOKENS, shadow: SHADOW_TOKENS, radius: ["pill"], ease: ["tk-out", "tk-in", "tk-in-out"] },
    classGroups: {
      z: [{ z: Z_TOKENS }],
      duration: [{ duration: ["fast", "base", "slow", "exit-fast", "exit-base", "exit-slow"] }],
    },
  },
});

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Format a "YYYY-MM-DD" value for display.
//
// The Date constructor parses a date-only ISO string as UTC midnight, while
// toLocaleDateString renders in the viewer's zone — so every viewer behind UTC
// saw the previous day. Building the date from its parts makes the constructor
// treat it as local, which is what a travel date means to the person reading it.
export function formatDateOnly(value, options = { day: "numeric", month: "short" }) {
  if (!value) return "";
  const parts = String(value).slice(0, 10).split("-").map(Number);
  const d = parts.length === 3 && parts.every(Number.isFinite)
    ? new Date(parts[0], parts[1] - 1, parts[2])
    : new Date(value);
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleDateString([], options);
}
